{
  "title": "Partenaires",
  "subtitle": "Revendeurs qui vendent OnBrand Mail à leurs propres clients.",
  "addPartner": "Ajouter un partenaire",
  "loadError": "Impossible de charger les partenaires",
  "emptyTitle": "Aucun partenaire pour l’instant",
  "emptyDescription": "Un partenaire vend à ses propres clients et conserve une marge. Ajoutez-en un, puis attribuez-lui ses clients depuis chaque locataire.",
  "colPartner": "Partenaire",
  "colMargin": "Marge",
  "colCustomers": "Clients",
  "colStatus": "Statut",
  "colPayouts": "Versements",
  "colCustomer": "Client",
  "colPaid": "Payé",
  "colRate": "Taux",
  "colEarned": "Gagné",
  "statusPending": "En attente",
  "statusActive": "Actif",
  "statusSuspended": "Suspendu",
  "payoutsNotOnboarded": "Non intégré",
  "payoutsOnboarding": "Intégration",
  "payoutsReady": "Prêt",
  "payoutsRestricted": "Restreint",
  "payoutsBadge": "Versements : {{status}}",
  "marginBadge": "Marge {{margin}}",
  "commissionOwed": "Dû",
  "commissionPaid": "Payé",
  "commissionReversed": "Annulé",
  "commissionHeld": "Retenu",
  "updateError": "Impossible de mettre à jour ce partenaire.",
  "stripeOnboardingError": "Impossible d’envoyer l’invitation Stripe.",
  "partnerVerb": "{{name}} {{verb}}.",
  "partnerAdded": "{{name}} ajouté.",
  "partnerAddedInvited": "{{name}} ajouté et invité à configurer les versements Stripe.",
  "partnerAddedNoEmail": "{{name}} ajouté — l’e-mail d’invitation n’a pas pu être envoyé. Ouvrez le partenaire et renvoyez l’invitation.",
  "verbReactivated": "réactivé",
  "verbSuspended": "suspendu",
  "activate": "Activer",
  "reactivate": "Réactiver",
  "suspend": "Suspendre",
  "emailStripeInvite": "Envoyer l’invitation Stripe",
  "resendStripeInvite": "Renvoyer l’invitation Stripe",
  "stripeInviteSent": "Invitation Stripe envoyée à {{email}}.",
  "stripeInviteCopy": "Impossible d’envoyer l’e-mail à {{email}}. Lien d’invitation copié dans le presse-papiers.",
  "stripeAlreadyOnboarded": "Ce partenaire a déjà terminé la configuration des versements Stripe.",
  "startStripeOnboarding": "Envoyer l’invitation Stripe",
  "newOnboardingLink": "Renvoyer l’invitation Stripe",
  "marginPercent": "Marge (%)",
  "billingEmail": "E-mail de facturation",
  "billingEmailDescription": "Où partent les factures, relevés de commission et l’invitation Stripe.",
  "billingEmailPlaceholder": "accounts@northern-it.example",
  "commissions": "Commission",
  "noCommissions": "Rien gagné pour l’instant. La commission est enregistrée lorsqu’un client référé paie une facture, pas lorsqu’elle est émise.",
  "createTitle": "Ajouter un partenaire",
  "createIntro": "Un partenaire vend à ses propres clients et conserve une marge sur le prix catalogue. Attribuez-lui ensuite ses clients depuis chaque locataire.",
  "createError": "Impossible d’ajouter ce partenaire",
  "createErrorShort": "Impossible d’ajouter ce partenaire.",
  "partnerFallback": "Partenaire",
  "nameLabel": "Nom",
  "namePlaceholder": "Northern IT",
  "slugLabel": "Slug",
  "slugDescription": "Apparaît dans les routes du portail et les journaux. Minuscules, chiffres et tirets.",
  "slugPlaceholder": "northern-it",
  "marginLabel": "Marge",
  "marginDescription": "Part du prix catalogue que ce partenaire conserve.",
  "stripePayouts": "Versements Stripe",
  "stripeActive": "Stripe acceptera les transferts vers ce partenaire. La commission est envoyée toutes les heures.",
  "stripeNeedsInfo": "Stripe demande encore des informations avant de payer ce partenaire. La commission continue de s’accumuler entre-temps et est envoyée dès que possible.",
  "stripeNeedsOnboarding": "Ce partenaire ne peut pas recevoir de commission tant qu’il n’a pas terminé l’intégration Stripe. Nécessaire uniquement pour les clients référés — les partenaires grossistes sont facturés à la place.",
  "customersAttributed": "{{count}} client attribué. Les clients grossistes sont facturés à ce partenaire à {{wholesale}} du prix catalogue ; les clients référés nous paient directement et la marge est transférée une fois que nous sommes payés.",
  "customersAttributed_other": "{{count}} clients attribués. Les clients grossistes sont facturés à ce partenaire à {{wholesale}} du prix catalogue ; les clients référés nous paient directement et la marge est transférée une fois que nous sommes payés.",
  "suspendedAlert": "Suspendu : aucun nouveau client ne peut être attribué et aucun nouvel abonnement ne peut leur être facturé. Les abonnements déjà en cours ne sont pas touchés.",
  "statementError": "Impossible de charger le relevé",
  "multiCurrencyNote": "Ces entrées couvrent plus d’une devise, aussi les totaux ci-dessus sont des comptes d’unités mineures plutôt qu’un montant. Lisez plutôt les lignes.",
  "offboardedCustomer": "Client désinscrit",
  "noAccessTitle": "Pas d’accès aux partenaires",
  "noAccessBody": "Les accords revendeurs sont gérés par le personnel OnBrand Mail.",
  "viewAs": "Voir en tant que partenaire",
  "viewAsStarted": "Portail affiché en tant que {{name}}.",
  "viewAsError": "Impossible de démarrer la vue partenaire.",
  "viewAsBannerTitle": "Vue en tant que {{name}}",
  "viewAsBannerBody": "Vous ne voyez que les clients de ce partenaire et ce à quoi leurs administrateurs ont accès. Les outils d’administration de la plateforme restent masqués jusqu’à la sortie.",
  "exitViewAs": "Quitter la vue partenaire",
  "viewAsExitError": "Impossible de quitter la vue partenaire.",
  "resendPortalInvite": "Renvoyer l’invitation au portail",
  "portalAccess": "Accès au portail",
  "portalAccessHint": "Permet de se connecter et d’administrer les clients de ce partenaire. Distinct de la configuration des versements Stripe.",
  "portalInviteTitle": "Inviter au portail",
  "portalInviteHint": "Envoyez un e-mail à {{name}} pour qu’ils se connectent et configurent leur compte partenaire. La connexion suffit — aucun mot de passe à créer.",
  "portalInviteEmail": "E-mail professionnel",
  "portalInviteEmailDesc": "L’adresse avec laquelle ils se connecteront. Par défaut, le contact de facturation.",
  "portalInviteDifferentOrgDesc": "Les partenaires se connectent presque toujours depuis leur propre annuaire. Décochez seulement s’ils partagent le vôtre.",
  "portalInviteSent": "Invitation au portail envoyée à {{email}}.",
  "portalInviteResent": "Invitation au portail renvoyée à {{email}}.",
  "portalInviteNoEmailTitle": "{{email}} invité — l’e-mail n’a pas pu être envoyé",
  "portalInviteNoEmailBody": "L’invitation attend. Demandez-leur de se connecter avec cette adresse ; le rôle s’applique à leur arrivée.",
  "portalInviteErrorTitle": "Non invité",
  "portalInviteError": "Impossible d’envoyer cette invitation au portail."
}
